import { type Props } from "../types";
import styles from "./styles.module.scss";
import { deleteTrash } from "#/assets/cart";

export const Counter = (props: Props) => {
  const {
    count,
    maxCount,
    handleIncrement,
    isEditing,
    handleInputChange,
    handleKeyPress,
    handleBlur,
    setIsEditing,
    handleDecrement,
    handleClean,
  } = props;

  return (
    <div className={styles["counter"]}>
      {count < maxCount ? (
        <div
          className={styles["counter__plus--active"]}
          onClick={handleIncrement}
        >
          +
        </div>
      ) : (
        <div
          className={styles["counter__plus--disabled"]}
          onClick={handleIncrement}
        >
          +
        </div>
      )}
      {isEditing ? (
        <input
          value={count}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyPress}
          autoFocus
          className={styles["counter__input"]}
        />
      ) : (
        <span
          style={count === 0 || count === maxCount ? { margin: "auto" } : {}}
          onClick={() => setIsEditing(true)}
          className={styles["counter__input"]}
        >
          {count}
        </span>
      )}

      {count > 1 && count <= maxCount && (
        <div className={styles["counter__minus"]} onClick={handleDecrement}>
          -
        </div>
      )}

      {count === 1 && (
        <img
          src={deleteTrash}
          alt={"delete-icon"}
          width={16}
          height={16}
          className={styles["counter__minus"]}
          onClick={handleDecrement}
        />
      )}
    </div>
  );
};
